import { CircularProgress } from '@mui/material';
import { Box } from '@mui/system';

const AppInit = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default AppInit;
